interface Props {
  /** Liga directa a .mp4/.webm/.mov, o a YouTube/Vimeo. Null/vacío = no se renderiza nada. */
  url: string | null;
  className?: string;
}

const ARCHIVO_DIRECTO = /\.(mp4|webm|mov)(\?.*)?$/i;

/** Video embebido: archivo directo con <video>, o iframe para YouTube/Vimeo. No renderiza nada si `url` es invalida. */
export function VideoEmbed({ url, className }: Props) {
  if (!url || !url.startsWith('https://')) return null;

  // aspect-video en ambas ramas: sin esto, un .mp4 vertical/alto puede inflar
  // la altura de toda la sección (el <video> sin aspect-ratio fijo hereda el
  // aspecto nativo del archivo en vez del recuadro 16:9 del diseño).
  const clases = ['aspect-video w-full rounded-xl object-cover', className].filter(Boolean).join(' ');

  if (ARCHIVO_DIRECTO.test(url)) {
    // eslint-disable-next-line jsx-a11y/media-has-caption
    return <video className={clases} src={url} controls playsInline />;
  }

  return (
    <iframe
      className={clases}
      src={url}
      title="Video del evento"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
}
